import { GET_ALL_NOTIFICATIONS, ADD_NOTIFICATION_REAL_TIME } from './types'

const initialState = {
  notifications: [],
}

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload.data,
        unreadNotificationsCount: action.payload.count,
      }
    case ADD_NOTIFICATION_REAL_TIME: {
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      }
    }
    default:
      return state
  }
}

export default notificationReducer
